import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const SidebarContainer = styled.div`
  width: 250px;
  background-color: #f8f9fa;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  padding-top: 60px;
  border-right: 1px solid #e9ecef;
`;

const Logo = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #1A2440;
  padding: 20px;
  margin-bottom: 20px;
`;

const NavItem = styled(NavLink)`
  display: block;
  padding: 15px 20px;
  color: #495057;
  text-decoration: none;
  font-size: 16px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #e9ecef;
  }
  
  &.active {
    background-color: #1A2440;
    color: white;
    font-weight: 500;
  }
`;

const Sidebar: React.FC = () => {
  return (
    <SidebarContainer>
      <Logo>CIM Analyzer</Logo>
      <nav>
        <NavItem to="/overview" className={({ isActive }) => isActive ? 'active' : ''}>
          Overview
        </NavItem>
        <NavItem to="/financials" className={({ isActive }) => isActive ? 'active' : ''}>
          Financials
        </NavItem>
        <NavItem to="/risks" className={({ isActive }) => isActive ? 'active' : ''}>
          Risks
        </NavItem>
        <NavItem to="/valuation" className={({ isActive }) => isActive ? 'active' : ''}>
          Valuation
        </NavItem>
        <NavItem to="/management" className={({ isActive }) => isActive ? 'active' : ''}>
          Management
        </NavItem>
        <NavItem to="/qa" className={({ isActive }) => isActive ? 'active' : ''}>
          Q&A
        </NavItem>
      </nav>
    </SidebarContainer>
  );
};

export default Sidebar;
